import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { authService } from '../services/auth-service';

/**
 * Auth callback component that handles the OAuth code exchange
 * This component should be rendered at the /auth/callback route
 */
export function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const processedRef = useRef(false);

  useEffect(() => {
    // Prevent multiple executions
    if (processedRef.current) return;
  processedRef.current = true;
    const handleCallback = async () => {
      try {
        console.log('Auth callback started, current URL:', window.location.href);
        const currentUrl = window.location.href;
        await authService.handleCallback(currentUrl);
      } catch (error) {
        console.error('Auth callback failed:', error);
        const errorMessage = error instanceof Error ? error.message : 'Unknown error';
        console.error('Detailed error:', errorMessage);
        navigate(`/login?error=callback_failed&details=${encodeURIComponent(errorMessage)}`, { replace: true });
      }
    };

    handleCallback();
  }, []); // Empty dependency array to run only once

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
        <p className="text-gray-600">Completing sign in...</p>
      </div>
    </div>
  );
}
